<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      title="投产方案"
      id-key="UserId"
    >
      <template slot="form">
        <el-tabs>
          <el-tab-pane label="可用量参数">
            <table class="table text-center" width="100%">
              <tr>
                <td></td>
                <td>加项</td>
                <td></td>
                <td>减项</td>
                <td></td>
              </tr>
              <tr>
                <td rowspan="3">库存可用量 =</td>
                <td>
                  现存量
                  <el-tooltip placement="top" content="仓库中现有库存的数量">
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                <td>
                  <el-checkbox v-model="IsStock"></el-checkbox>
                </td>
                <td>
                  安全库存
                  <el-tooltip
                    placement="top"
                    content="存货档案中设置的安全库存，与最低库存只能选一个，不能同时选"
                  >
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                <td>
                  <el-checkbox v-model="IsSafetyStock"></el-checkbox>
                </td>
              </tr>
              <tr>
                <td>
                  生产待入量
                  <el-tooltip
                    placement="top"
                    content="加工单已审核，但未生成产成品入库单的数量"
                  >
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                <td>
                  <el-checkbox v-model="IsProduction"></el-checkbox>
                </td>
                <td>
                  最低库存
                  <el-tooltip
                    placement="top"
                    content="存货档案中设置的最低库存，与安全库存只能选一个，不能同时选"
                  >
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                 <td>
                  <el-checkbox v-model="IsMinStock"></el-checkbox>
                </td>
              </tr>
              <tr>
                <td>
                  委外待入量
                  <el-tooltip
                    placement="top"
                    content="已审核委外加工单未入库产品的量"
                  >
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                <td>
                  <el-checkbox v-model="IsOutsourcing"></el-checkbox>
                </td>
                <td>
                  销售订单占用量
                  <el-tooltip
                    placement="top"
                    content="指已开具销售订单承诺给客户但还未销货的量"
                  >
                    <cloth-icon icon="explain"></cloth-icon>
                  </el-tooltip>
                </td>
                 <td>
                  <el-checkbox v-model="IsSaleOrderCount"></el-checkbox>
                </td>
              </tr>
            </table>
            <div style="margin-top: 20px">
              <span>生产数量是否考虑可用量</span>
              <el-checkbox v-model="IsProductionAvailable" style="margin-left: 10px"></el-checkbox>
            </div>
          </el-tab-pane>
          <el-tab-pane label="参与运算的库存" v-if="false">
            <el-table :data="warehouseList">
               <el-table-column
                  prop="WarehouseNo"
                  label="仓库编码"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="WarehouseName"
                  label="仓库名称"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  label="参与运算"
                  fixed="right"
                  align="center"
                  width="80"
                >
                  <template slot-scope="{ row }">
                    <el-checkbox
                      v-model="row.IsUse"
                      @change="changeIsUse($event, row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import clothIcon from "./clothIcon.vue";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    clothIcon,
  },
  data() {
    return {
      warehouseApi: require('@/api/ba/warehouse').default,
      api: require('@/api/production/productionPlan').default,
      warehouseList: [],
      list: [], // 勾选的仓库
      ProductionPlanId: 0,
      IsStock: false,
      IsProduction: false,
      IsOutsourcing: false,
      IsSafetyStock: false,
      IsMinStock: false, 
      IsSaleOrderCount: false,
      IsProductionAvailable: false,
    };
  },
  methods: {
    setWarehouseList(){
      let p1 = this.api.info();
      let p2 = this.warehouseApi.list({Status: 1});
      Promise.all([p1, p2]).then(res => {
        let data1 = res[0];
        let data2 = res[1];
        if(data1.Data.DetailModels.length === 0){
          
           data2.Data.forEach(item => {
            item.ProductionPlanDetailId = item.ProductionPlanDetailId ? item.ProductionPlanDetailId : 0
            item.ProductionPlanId = data1.Data.ProductionPlanId ? data1.Data.ProductionPlanId : 0
            item.IsUse = item.IsUse ? item.IsUse : false

          })
          let {ProductionPlanId} = data1.Data;
          this.ProductionPlanId = ProductionPlanId;

          this.warehouseList = data2.Data
        }else{
          this.warehouseList = data1.Data.DetailModels;

          let {
            ProductionPlanId,
            IsStock,
            IsProduction,
            IsOutsourcing,
            IsSafetyStock,
            IsMinStock,
            IsSaleOrderCount,
            IsProductionAvailable
          } = data1.Data;

          this.ProductionPlanId = ProductionPlanId;
          this.IsStock = IsStock;
          this.IsProduction = IsProduction;
          this.IsOutsourcing = IsOutsourcing;
          this.IsSafetyStock = IsSafetyStock;
          this.IsMinStock = IsMinStock;
          this.IsSaleOrderCount = IsSaleOrderCount;
          this.IsProductionAvailable = IsProductionAvailable;

          
        }
      })
      
    },
    changeIsUse(row){
      if(row.T == 0){
        row.T = 1
      }
    },
    save(){
      let DetailModels = this.warehouseList.map(item => {
        return {
          T: item.T != null ? 1 : 0,
          ProductionPlanDetailId: item.ProductionPlanDetailId,
          ProductionPlanId: item.ProductionPlanId,
          WarehouseId: item.WarehouseId,
          IsUse: item.IsUse,
          WarehouseName: item.WarehouseName,
          WarehouseNo: item.WarehouseNo,
        }
      })

      let o = {
        DetailModels,
        ProductionPlanId: this.ProductionPlanId,
        IsStock: this.IsStock,
        IsProduction: this.IsProduction,
        IsOutsourcing: this.IsOutsourcing,
        IsSafetyStock: this.IsSafetyStock,
        IsMinStock: this.IsMinStock, 
        IsSaleOrderCount: this.IsSaleOrderCount,
        IsProductionAvailable: this.IsProductionAvailable,
      }

      var loading = this.$loading({
          lock: true,
          text: "正在保存...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });

      this.api.save(o).then(res => {
        loading.close();
        this.close(true);
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg})
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
      })
    }
    
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin-top: 18px;
  border-collapse: collapse;
}

.table td {
  line-height: 32px;
  border: 1px solid #e4e7ed;
}

.text-center {
  text-align: center;
}
</style>
